/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtract_One_FrameInputs */

const en_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Frame`)
};

const fr_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 image`)
};

const de_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Rahmen`)
};

const it_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 fotogramma`)
};

const ru_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 кадр`)
};

const es_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 fotograma`)
};

const zh_cn2_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1帧`)
};

const ja_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1フレーム`)
};

const hi_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 फ्रेम`)
};

const pt_pt2_subtract_one_frame = /** @type {(inputs: Subtract_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Quadro`)
};

/**
* | output |
* | --- |
* | "1 Frame" |
*
* @param {Subtract_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtract_one_frame = /** @type {((inputs?: Subtract_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtract_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtract_one_frame(inputs)
	if (locale === "de") return de_subtract_one_frame(inputs)
	if (locale === "it") return it_subtract_one_frame(inputs)
	if (locale === "ru") return ru_subtract_one_frame(inputs)
	if (locale === "es") return es_subtract_one_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_subtract_one_frame(inputs)
	if (locale === "ja") return ja_subtract_one_frame(inputs)
	if (locale === "hi") return hi_subtract_one_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_subtract_one_frame(inputs)
	return en_subtract_one_frame(inputs)
});